import { Root, Slottable } from '@radix-ui/react-slot'
import PriceWithDiscount from '@repo/ui/components/price-with-discount'
import { cn } from '@repo/ui/lib/utils'
import { LinkProps } from 'next/dist/client/link'
import Link from 'next/link'
import { AnchorHTMLAttributes, ComponentPropsWithoutRef, ElementType, FunctionComponent, ReactNode } from 'react'

interface Props extends ComponentPropsWithoutRef<'li'> {
  linkProps: LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>
  title?: string
  price?: number
  discount?: number
  currencyCode?: string
  mediaPrimary?: ReactNode
  mediaSecondary?: ReactNode
  className?: string
  rootAs?: ElementType
  titleAs?: ElementType
  wishlist?: ReactNode
}

const ProductPreviewCard: FunctionComponent<Props> = ({
  linkProps,
  title,
  price,
  discount = 0,
  currencyCode = 'EUR',
  mediaPrimary,
  mediaSecondary,
  className,
  rootAs = 'li',
  titleAs = 'h3',
  wishlist,
  ...rest
}) => {
  const TypeRoot = rootAs
  const TypeTitle = titleAs

  return (
    <TypeRoot className={cn('flex shrink-0 flex-col gap-2 overflow-hidden', className)} {...rest}>
      <Link
        {...linkProps}
        className='bg-card focus-visible:border-ring focus-visible:outline-hidden group relative aspect-[2/3] overflow-hidden rounded-lg border border-solid border-transparent'
      >
        {mediaPrimary}
        {mediaSecondary && <div className='absolute inset-0 opacity-0 transition-opacity ease-out group-hover:opacity-100 group-focus-visible:opacity-100'>{mediaSecondary}</div>}
        <Root className='absolute right-0 top-0 pb-4 pl-4 pr-2 pt-2 ease-out lg:opacity-0 lg:transition-opacity lg:group-hover:opacity-100 lg:group-focus-visible:opacity-100'>
          <Slottable>{wishlist}</Slottable>
        </Root>
      </Link>
      <div className='px-miista-product-preview-inner flex flex-col gap-1 text-sm uppercase'>
        <TypeTitle className='truncate' title={title}>
          {title}
        </TypeTitle>
        {price && <PriceWithDiscount className='flex items-center' amount={price} discount={discount} currencyCode={currencyCode} />}
      </div>
    </TypeRoot>
  )
}

export default ProductPreviewCard
